import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { RoutingService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { RecaptchaService } from 'src/app/shared/services/recaptcha.service';
import { ForgotUserPasswordService } from '../forgot-user-password.service';

declare const grecaptcha: any;

declare global {
  interface Window {
    onRecaptchaLoad: () => void;
  }
}

@Component({
    selector: 'app-forgot-user-password',
    templateUrl: './forgot-user-password.component.html',
    styleUrls: ['./forgot-user-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ForgotUserPasswordComponent implements OnInit, OnDestroy, AfterViewInit {
  passwordResetForm: FormGroup;
  recoverPasswordForm: FormGroup;
  recoverPasswordrequired = false;
  passwordResetRequired = false;
  emailRegex: any = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/;
  emailSubscription: any;
  recaptchaEnabled = false;
  siteKey: string | null = null;
  subRecaptcha: Subscription;
  widgetId: any;

  constructor(
    private readonly fb: FormBuilder,
    private readonly forgotUserPasswordService: ForgotUserPasswordService,
    private readonly route: RoutingService,
    private readonly recaptchaService: RecaptchaService
  ) { }

  ngAfterViewInit(): void {
    if (window['grecaptcha'] && window['grecaptcha'].enterprise) {
      this.loadRecaptcha();
    }
  }

  ngOnInit() {
    this.passwordResetForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(this.emailRegex)]],
      captchaToken: new FormControl('', Validators.required)
    });

    this.subRecaptcha = this.recaptchaService
      .isEnabled$()
      .subscribe((enabled) => {
        this.recaptchaEnabled = enabled;
        this.siteKey = this.recaptchaService.getSiteKey();
        if (enabled) {
          this.passwordResetForm.addControl(
            'captchaToken',
            new FormControl('', Validators.required)
          );
        }
      });
    window['onRecaptchaLoad'] = () => this.loadRecaptcha();
  }

  private loadRecaptcha() {
    const container = document.getElementById('recaptcha-container');
    if (!container || !window['grecaptcha'] || !grecaptcha.enterprise.render) {
      console.error('Recaptcha not ready');
      return;
    }

    this.widgetId = grecaptcha.enterprise.render('recaptcha-container', {
      sitekey: this.siteKey,
      theme: 'light',
      size: 'normal',
      callback: (token: string) => this.onCaptchaSuccess(token)
    });
  }

  private onCaptchaSuccess(token: string) {
    //console.log('Captcha success token:', token);
    this.passwordResetForm.patchValue({ captchaToken: token });
  }

  submitrecoverPasswordForm() {
    if (this.recoverPasswordForm.invalid) {
      if (this.recoverPasswordForm.controls.email.errors?.required) {
        this.recoverPasswordrequired = true;
      }
      return false;
    }
    const params: any = {
      accountNumber: '',
      email: this.recoverPasswordForm.value.email,
      forgotPassword: false,
      forgotUsername: true,
      name: '',
      passwordAnswer: '',
      passwordQuestion: '',
    };
    this.forgotUserPasswordService.validateEmailId(params);
    this.emailSubscription =
      this.forgotUserPasswordService.validateEmail$.subscribe((res) => {
        this.gotoQuestionPasswordPage(res);
      });
    return true;
  }

  ngOnDestroy() {
    if (this.emailSubscription) {
      this.emailSubscription.unsubscribe();
    }
    this.subRecaptcha?.unsubscribe();
  }

  validateRecoverPassword() {
    if (!this.recoverPasswordForm.controls.email.errors?.required) {
      this.recoverPasswordrequired = false;
    }
  }

  validatepasswordReset() {
    if (!this.passwordResetForm.controls.email.errors?.required) {
      this.passwordResetRequired = false;
    }
  }

  gotoQuestionPasswordPage(questionInfo: any) {
    if (questionInfo !== null) {
      if (questionInfo && questionInfo.passwordQuestion) {
        this.route.goByUrl('/login/userdatarecoveryaction');
      } else {
        this.route.goByUrl('/login/helphintquestionrecovery');
      }
    }
  }
  showCaptchaErrorMsg = false;

  submitpasswordResetForm() {
    if (this.passwordResetForm.invalid) {
      if (this.passwordResetForm.controls.email.errors?.required)
        this.passwordResetRequired = true;
      else if (this.passwordResetForm.controls.captchaToken.errors?.required)
        this.showCaptchaErrorMsg = true;
      return false;
    }
    const params: any = {
      accountNumber: '',
      email: this.passwordResetForm.value.email,
      forgotPassword: true,
      forgotUsername: false,
      name: '',
      passwordAnswer: '',
      passwordQuestion: '',
      captchaToken: this.passwordResetForm.value.captchaToken,
    };
    this.forgotUserPasswordService.validateEmailId(params);
    this.emailSubscription =
      this.forgotUserPasswordService.validateEmail$.subscribe((res) => {
        this.gotoQuestionPasswordPage(res);
      });
    return true;
  }
}
